<template>
  <template v-if="!isEmpty(relevantSymbol)">
    <NText
      variant="caption1"
      weight="medium"
      class="text-neutral-secondary-press block text-right pr-3 mb-2 mt-3"
    >
      {{ t('search.most_relevant_result') }}
      {{ label }}
    </NText>

    <SymbolSearchResultItem
      :symbol="relevantSymbol ?? null"
      :term="term"
      @handle-symbol-click="emit('handleSymbolClick', relevantSymbol)"
    />
  </template>

  <template v-for="(symbols, key) in groupedSymbols" :key="key">
    <template v-if="symbols.length">
      <NText
        variant="caption1"
        weight="medium"
        class="text-neutral-secondary-press block pr-3 mb-2 mt-3 text-right"
      >
        {{ SYMBOLS_CATEGORY_LABEL[key] }}
      </NText>

      <SymbolSearchResultItem
        v-for="(symbol, index) of symbols"
        :key="`${symbol.isin}${index}`"
        :relevant-symbol-isin="relevantSymbol?.isin ?? ''"
        :term="term"
        :symbol="symbol"
        @handle-symbol-click="emit('handleSymbolClick', symbol)"
      />
    </template>
  </template>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { isEmpty } from '@libs/utils';
import { GroupedSymbols, SymbolResult } from '@libs/api-reference';
import { computed } from 'vue';

import {
  SYMBOLS_CATEGORY_LABEL,
  SYMBOLS_TYPE_CODES_CATEGORY,
} from '@/modules/symbol';

import SymbolSearchResultItem from './SymbolSearchResultItem.vue';

type SymbolSearchResultPropsType = {
  term: string;
  groupedSymbols: GroupedSymbols;
  relevantSymbol?: SymbolResult;
};

const props = withDefaults(defineProps<SymbolSearchResultPropsType>(), {
  term: '',
  relevantSymbol: undefined,
});

const emit = defineEmits(['changeFavoriteStatus', 'handleSymbolClick']);

const { t } = useI18n();

const label = computed(() => {
  if (props.relevantSymbol && props.relevantSymbol.instrumentTypeCode) {
    return SYMBOLS_CATEGORY_LABEL[
      SYMBOLS_TYPE_CODES_CATEGORY[props.relevantSymbol.instrumentTypeCode]
    ];
  }

  return '';
});
</script>
